export default {
  props: {
    supplies: Array,
  },
};
